import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GameCardBase, GC_BASE_CSS } from '@/src/app/uygulamalar/hmi-pano/pano/game-card-base';

@Component({
  selector: 'revizyon-kart',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="gc gc--revizyon" (mousemove)="mouseMove($event)" (mouseleave)="mouseLeave()" [ngStyle]="kartStil">
      <div class="gc-canli-bg"></div><div class="gc-parlak-kenar"></div>
      <div class="gc-kose gc-kose--sol-ust"></div><div class="gc-kose gc-kose--sag-ust"></div><div class="gc-kose gc-kose--sol-alt"></div><div class="gc-kose gc-kose--sag-alt"></div>
      <div class="gc-kose-ic gc-kose-ic--sol-ust"></div><div class="gc-kose-ic gc-kose-ic--sag-ust"></div><div class="gc-kose-ic gc-kose-ic--sol-alt"></div><div class="gc-kose-ic gc-kose-ic--sag-alt"></div>
      <div class="gc-rarity-serit"></div><div class="gc-ic-glow"></div><div class="gc-desen"></div><div class="gc-shimmer"></div><div class="gc-holo"></div>
      <div class="gc-kenar-glow" [style.background]="kenarGlow"></div>
      <div class="gc-parcaciklar"><span class="gc-p gc-p--buyuk" style="--d:9s;--x:10%;--y:20%"></span><span class="gc-p" style="--d:12s;--x:80%;--y:40%"></span><span class="gc-p gc-p--kucuk" style="--d:7s;--x:45%;--y:75%"></span></div>
      <div class="gc-icerik">
        <div class="gc-hud-baslik">REVİZYON</div>
        <div class="rv-ust">
          <div class="rv-no">Rev. {{ p()?.revizyonNo || 1 }}</div>
          @if (p()?.fiyatDegisikligi) { <div class="rv-fiyat-badge">{{ p().fiyatDegisikligi }}</div> }
        </div>
        @if (p()?.aciklama) { <div class="rv-aciklama">{{ p().aciklama }}</div> }
        <div class="gc-xp-bar"><div class="gc-xp-dolgu" [style.width.%]="gorunur() ? 55 : 0"></div></div>
      </div>
    </div>
  `,
  styles: [GC_BASE_CSS, `
    .gc { --accent: #4338ca; --accent-rgb: 67,56,202; }
    .rv-ust { display: flex; justify-content: space-between; align-items: center; gap: 8px; }
    .rv-no { font-size: 18px; font-weight: 900; color: #818cf8; font-variant-numeric: tabular-nums; text-shadow: 0 0 10px rgba(129,140,248,.3); }
    .rv-fiyat-badge { font-size: 10px; font-weight: 700; padding: 2px 8px; border-radius: 2px; color: #fbbf24; background: rgba(251,191,36,0.15); }
    .rv-aciklama { font-size: 10px; color: var(--py-metin-ikincil, #64748b); line-height: 1.4; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
  `],
})
export class RevizyonKartComponent extends GameCardBase {
  parametreler = input<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
}
